// extracted by mini-css-extract-plugin
export var aircallIframe = "_i2-3";
export var fabContainer = "_i2-5";
export var fabRinging = "_i2-6";
export var loadingOverlay = "_i2-4";
export var pulse = "_i2-7";
export var widgetContent = "_i2-2";
export var widgetPanel = "_i2-0";
export var widgetPanelExpanded = "_i2-1";